<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 09:55:49
 * @LastEditTime: 2020-06-21 17:37:24
 * @Description: 简答题
 -->
<template>
  <div class="short">
    <div class="title">
      <span>{{ title }}</span>
      <div
        v-if="stemMediaInfoVO.mediaPath"
        class="look-media"
        @click="lookMedia(stemMediaInfoVO)">查看多媒体</div>
    </div>
    <div class="content">
      <i-input type="textarea" :rows="5" readonly :value="question.userAnswer" />
    </div>
    <div class="analysis">
      <div class="analysis-left">
        <p>正确答案：{{ correctAnswer }}</p>
        <p>解析说明：{{ tip !== undefined ? tip : '无' }}</p>
      </div>
      <div class="analysis-right">
        <span class="bold">得分：</span>
        <i-input-number
          :disabled="!maker"
          :value="question.score ? question.score : 0"
          :max="question.totalScore"
          :min="0"
          :step="1" size="small" @on-change="shortScoreChangeHandler" />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from '../../../../../utils';

export default {
  name: 'ShortQuestion',
  props: {
    index: { type: Number, required: true },
    question: { type: Object, required: true },
    maker: { type: Boolean, required: true },
    oldTotalScore: { type: [Number, String], required: true },
  },
  data() {
    return {
      correctAnswer: '',
      tempScore: 0,
    };
  },
  computed: {
    title() {
      return `${this.index + 1}、${this.question.content}（${this.question.totalScore}分）`;
    },
    options() {
      return this.question.options;
    },
    tip() {
      return this.question.tip;
    },
    stemMediaInfoVO() {
      return this.question.mediaInfoVO ? this.question.mediaInfoVO : {};
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        options.forEach((option) => {
          if (option.correct) {
            this.correctAnswer = option.content;
            // eslint-disable-next-line no-useless-return
            return;
          }
        });
      },
    },
  },
  methods: {
    lookMedia({ mediaContentType, mediaPath, videoCover }) {
      this.$emit('preview-media', { mediaContentType, mediaPath, videoCover });
    },
    /**
     * 简答题分数修改处理函数
     */
    shortScoreChangeHandler: debounce(function (score) {
      this.tempScore = score;

      if (this.tempScore === null) {
        alert('分数不能为空！');
        return;
      }

      this.requestUpdateShortScoreAndSetting();
    }, 500),
    /**
     * 请求修改简答题分数并设置
     */
    // eslint-disable-next-line prefer-arrow-callback,func-names
    requestUpdateShortScoreAndSetting() {
      this.requestUpdateShortScore()
        .then(() => {
          this.$emit('set-question-score', { index: this.index, score: this.tempScore });
          this.$emit('repull-info');
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求修改简答题分数
     */
    requestUpdateShortScore() {
      const { paperId, userCode } = this.$route.query;
      const params = {
        paperId,
        userCode,
        id: this.question.id,
        oldScore: this.question.score,
        oldTotalScore: this.oldTotalScore,
        score: this.tempScore,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.paperDetailUpdateShortScore(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.short {
  width: 100%;

  > .title {
    margin-bottom: 16px;
  }

  > .analysis {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    background-color: #fbf9fb;

    > .analysis-left {
      > p {
        line-height: 26px;
      }
    }

    > .analysis-right {
      display: flex;
      align-items: center;

      /deep/ .ivu-input-number {
        width: 60px;
      }

      > .bold {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }

  .look-media {
    display: inline-block;
    color: #0C8CCA;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
    background-color: rgba(12, 140, 202, .1);
    border-radius: 6px;
    line-height: normal;
  }
}
</style>
